import {isNotNil} from 'ramda-adjunct';

export const getLID = (measureLiquidity?: number | null) =>
  isNotNil(measureLiquidity) ? Math.round(measureLiquidity) : null;
